<template>
  <div class="no-table-data" v-show="show">
    <div class="img">
      <img :src="require('@/assets/img/no_data.jpg')" alt="" />
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['show']
};
</script>
<style lang="scss" scoped>
.no-table-data {
  padding-top: 47px;
  .img {
    width: 272px;
    margin: 0 auto;
    img {
      display: block;
      width: 201px;
      margin: 0 auto;
    }
    p {
      padding-top: 16px;
      color: #707070;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>
